<div class="no-scroll patient-ob">

    <div class="wrapper">

        <!-- ========================== header (start) ========================== -->
        <header class="l-header">

            <div class="on-mobile header-logo">
                <img src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
            </div>
            <div class="l-header-panel">
                <h1 class="t-title-main">AutoText Lists</h1>

                <nav class="header-menu">
                    <a routerLink="/patsearch" class="header-menu-link icon-confirm" matTooltip="Exit"></a>
                </nav>

                <nav class="on-mobile header-mobilePanel">
                    <button class="btn-mobileMenu" id="open-headerMenu" data-show=".header-menu"
                        aria-label="open mobile menu"></button>
                    <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar"
                        aria-label="open mobile sidebar"></button>
                </nav>

            </div>

        </header>
        <!-- ========================== header (end) ========================== -->

        <main class="l-deashboard">

            <div class="clinic-autotext">
                <div class="content-row">
                    <div class="editor-panel">
                        <h3>{{ editingId ? 'Edit list' : 'New list' }}</h3>

                        <label class="field">
                            <span>Category name</span>
                            <input type="text" [(ngModel)]="title" placeholder="e.g. Neck US phrases" />
                        </label>

                        <div class="snippets">
                            <span class="field-label">Auto Texts</span>
                            <div class="snippet-row" *ngFor="let s of snippets; let i = index">
                                <textarea class="snippet-content" [(ngModel)]="s.Content" placeholder="Auto text" rows="2"></textarea>
                                <button type="button" class="orange-btn -sm" (click)="removeSnippetRow(i)">Remove</button>
                            </div>
                            <button type="button" class="blue-btn -sm" (click)="addSnippetRow()">Add Auto Text</button>
                        </div>

                        <div class="templates">
                            <span class="field-label">Clinics templates this list will appear next to</span>
                            <div class="template-select-list">
                                <label *ngFor="let t of clinicTemplates" class="template-select-item">
                                    <input type="checkbox" class="custom-check -sq" [checked]="isTemplateSelected(t.ClinicTemplateID)" (change)="toggleTemplate(t.ClinicTemplateID)" />
                                    <i class="customInput-display -sq"></i>
                                    <span>{{ t.Title }}</span>
                                </label>
                                <div *ngIf="!clinicTemplates.length" class="empty">No Clinics templates found yet.</div>
                            </div>
                        </div>

                        <div class="actions">
                            <button type="button" class="blue-btn" [disabled]="!title || loading" (click)="save()">
                                {{ editingId ? 'Update' : 'Create' }}
                            </button>
                            <button type="button" class="orange-btn" *ngIf="editingId" (click)="resetForm()" [disabled]="loading">Cancel</button>
                        </div>
                    </div>

                    <div class="list-panel">
                        <h3>Existing lists</h3>
                        <div class="list-list" *ngIf="lists.length">
                            <div class="list-card" *ngFor="let l of lists" [class.editing]="l.AutoTextListID === editingId">
                                <div class="list-card-title">{{ l.Title }}</div>
                                <div class="list-card-snippets">{{ l.snippets?.length || 0 }} Auto texts</div>
                                <div class="list-card-templates">
                                    <span *ngFor="let id of l.assignedClinicTemplateIds; let last = last">{{ templateLabel(id) }}{{ last ? '' : ', ' }}</span>
                                    <span *ngIf="!l.assignedClinicTemplateIds?.length" class="empty">Not assigned to any template</span>
                                </div>
                                <div class="list-card-actions">
                                    <button type="button" class="blue-btn" (click)="edit(l)" [disabled]="loading">Edit</button>
                                    <button type="button" class="orange-btn" (click)="confirmDelete(l)" [disabled]="loading">Delete</button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!lists.length" class="empty">No lists yet.</div>
                    </div>
                </div>
            </div>

        </main>

        <!-- ========================== main sidebar (start) ========================== -->

        <aside class="l-sidebar l-flex l-column">

            <img class="off-mobile sidebar-logo" src="assets/icons/logo.svg" alt="Artisan Sonics" />

            <nav class="mainNav l-fg1 scroller">
            </nav>

            <app-docpanel></app-docpanel>

        </aside>

        <!-- ========================== main sidebar (end) ========================== -->

        <app-bottombar></app-bottombar>

    </div><!-- end wrapper -->
</div>

<div *ngIf="showDeleteConfirm" class="t-popup popup-patientDetails popup-centered">
    <div class="t-popup-frame">
        <div class="t-popup-body">

            <button class="t-btn-popup-close" aria-label="close popup" (click)="cancelDelete()"></button>

            <h2 style="color: #D7A95B; text-align: center;">
                Delete list "{{ listToDelete?.Title }}"?
                <br>
                This cannot be undone.
            </h2>
            <div style="display: flex; justify-content: center;">
                <button class="blue-btn" [disabled]="loading" (click)="doDelete()">Yes</button>
                <button class="orange-btn" style="margin-left: 2em" [disabled]="loading" (click)="cancelDelete()">No</button>
            </div>

        </div>
    </div>
</div>
